<style lang="scss">
@media screen and (min-width: 55rem) {
  .newscontent-all {
    width: 100%;
    min-height: 60rem;
    height: 65rem;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 5rem;
    .el-carousel {
      width: 100%;
      height: 60rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      .el-carousel__container {
        width: 80% !important;
        max-width: 1080px;
        height: 60rem  !important;
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        .newscontent-container {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          // position: absolute;
        

          .newscontent-container-left {
            width: 30%;
            height: 60rem;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            // margin-left: 0.3rem;
            .newscontent-container-left-news {
              margin-left: 3%;
              width: 95%;
              height: 99%;
              background-position: center center;
              background-size: cover;
              position: relative;
              &:hover {
                cursor: pointer;
              }
              .newscontent-container-left-news-box {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 7rem;
                background: rgba(0, 0, 0, 0.245);
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-content: center;

                .newscontent-container-left-news-box-title {
                  width: 92%;
                  margin-left: 2rem;
                  text-align: left;
                  font-family: "PingFang SC", "Microsoft YaHei";
                  color: #fff;
                  font-size: 1.4rem;
                }
              }
            }
          }
          .newscontent-container-right {
            width: 70%;
            height: 60rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .newscontent-container-right-list {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: row;
              justify-content: space-around;
              align-items: flex-start;
              flex-wrap: wrap;

              .newscontent-container-right-item {
                width: 49%;
                height: 49%;
                background-position: center center;
                background-size: cover;
                position: relative;
                &:hover {
                  cursor: pointer;
                }
                .newscontent-container-right-news-box {
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  height: 7rem;
                  background: rgba(0, 0, 0, 0.245);
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-content: center;
                  .newscontent-container-right-news-box-title {
                    width: 92%;
                    margin-left: 2rem;
                    text-align: left;
                    font-family: "PingFang SC", "Microsoft YaHei";
                    color: #fff;
                    font-size: 1.4rem;
                  }
                }
              }
            }
          }
        }
      }
    }
    .el-carousel__indicator {
      background-color: #e5004f;
    }
    .el-carousel__button {
      width: 0.8rem;
      height: 3rem;
    }
    .news-pagionation {
      margin-top: 2rem;
    }
  }
}
@media screen and (max-width: 55rem) {
  .newscontent-all {
    width: 100%;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 5rem;
    height: 100%;
    min-height: 100rem;
    .el-carousel {
      width: 100%;
      height: 100%;
      min-height: 100rem;
      .el-carousel__container {
        width: 100%;
        height: 100%;
        min-height: 100rem;
        .newscontent-container {
          width: 100%;
          height: 100%;
          min-height: 100rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          .newscontent-container-left {
            width: 80%;
            height: 20rem;
            min-height: 20rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            // margin-left: 0.3rem;
            .newscontent-container-left-news {
              width: 100%;
              height: 98%;
              background-position: center center;
              background-size: cover;
              position: relative;
              &:hover {
                cursor: pointer;
              }
              .newscontent-container-left-news-box {
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 7rem;
                background: rgba(0, 0, 0, 0.245);
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-content: center;

                .newscontent-container-left-news-box-title {
                  width: 96%;
                  text-align: left;
                  font-family: "PingFang SC", "Microsoft YaHei";
                  color: #fff;
                  font-size: 1.2rem;
                  overflow: hidden;
                }
              }
            }
          }
          .newscontent-container-right {
            width: 80%;
            height: 100%;
            min-height: 20rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: flex-start;
            .newscontent-container-right-list {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: center;
              .newscontent-container-right-item {
                width: 100%;
                height: 20rem;
                background-position: center center;
                background-size: cover;
                position: relative;
                margin-top: 1rem;
                &:hover {
                  cursor: pointer;
                }
                .newscontent-container-right-news-box {
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  height: 7rem;
                  background: rgba(0, 0, 0, 0.245);
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  align-content: center;
                  .newscontent-container-right-news-box-title {
                    width: 96%;
                    text-align: left;
                    font-family: "PingFang SC", "Microsoft YaHei";
                    color: #fff;
                    font-size: 1.2rem;
                    overflow: hidden;
                  }
                }
              }
            }
          }
        }
      }
    }
    .el-carousel__indicator {
      background-color: #e5004f;
    }
    .news-pagionation {
      margin-top: 2rem;
    }
  }
}
</style>

<template>
  <!-- <div class="newscontent-all" @mousewheel="rollScroll($event)"> -->
  <div class="newscontent-all">
    <el-carousel
      arrow="always"
      @change="getData"
      :autoplay="false"
      direction="vertical"
      trigger="click"
      ref="carousel"
      indicator-position="none"
    >
      <el-carousel-item v-for="item in this.total_page" :key="item">
        <div class="newscontent-container">
          <div class="newscontent-container-left">
            <div
              class="newscontent-container-left-news"
              :style="`background-image:url('${newsList[0].picture_url}')`"
              @click="goto(newsList[0].link_url)"
            >
              <div class="newscontent-container-left-news-box">
                <div class="newscontent-container-left-news-box-title">
                  {{ newsList[0].title }}
                </div>
                <!-- <div class="newscontent-container-left-news-box-subtitle">
                  {{ newsList[0].subtitle }}
                </div> -->
              </div>
            </div>
          </div>

          <div class="newscontent-container-right">
            <div class="newscontent-container-right-list">
              <div
                v-if="newsList[1].flag"
                class="newscontent-container-right-item"
                :style="`background-image:url('${newsList[1].picture_url}')`"
                @click="goto(newsList[1].link_url)"
              >
                <div class="newscontent-container-right-news-box">
                  <div class="newscontent-container-right-news-box-title">
                    {{ newsList[1].title }}
                  </div>
                  <!-- <div class="newscontent-container-right-news-box-subtitle">
                    {{ newsList[1].subtitle }}
                  </div> -->
                </div>
              </div>
              <div
                v-if="newsList[2].flag"
                class="newscontent-container-right-item"
                :style="`background-image:url('${newsList[2].picture_url}')`"
                @click="goto(newsList[2].link_url)"
              >
                <div class="newscontent-container-right-news-box">
                  <div class="newscontent-container-right-news-box-title">
                    {{ newsList[2].title }}
                  </div>
                  <!-- <div class="newscontent-container-right-news-box-subtitle">
                    {{ newsList[2].subtitle }}
                  </div> -->
                </div>
              </div>
              <div
                v-if="newsList[3].flag"
                class="newscontent-container-right-item"
                :style="`background-image:url('${newsList[3].picture_url}')`"
                @click="goto(newsList[3].link_url)"
              >
                <div class="newscontent-container-right-news-box">
                  <div class="newscontent-container-right-news-box-title">
                    {{ newsList[3].title }}
                  </div>
                  <!-- <div class="newscontent-container-right-news-box-subtitle">
                    {{ newsList[3].subtitle }}
                  </div> -->
                </div>
              </div>
              <div
                v-if="newsList[4].flag"
                class="newscontent-container-right-item"
                :style="`background-image:url('${newsList[4].picture_url}')`"
                @click="goto(newsList[4].link_url)"
              >
                <div class="newscontent-container-right-news-box">
                  <div class="newscontent-container-right-news-box-title">
                    {{ newsList[4].title }}
                  </div>
                  <!-- <div class="newscontent-container-right-news-box-subtitle">
                    {{ newsList[4].subtitle }}
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="text-center news-pagionation">
      <v-pagination
        v-model="page"
        :total-visible="7"
        :length="total_page"
        @input="getNextPage"
        color="#e5004f"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { fetchNews } from "@/yintai/api/news";

export default {
  name: "newsContent",
  components: {},
  data() {
    return {
      newsList: [],
      page: 1,
      total: 0,
      total_page: 0,
    };
  },
  async mounted() {
    this.getData(this.page);
  },
  methods: {
    async getData(data) {
      const result = await fetchNews({ page: data, limit: 5 });
      this.newsList = result.data.data.data;

      for (let k = 0; k < this.newsList.length; k++) {
        this.newsList[k].flag = true;
      }

      let i = 5 - this.newsList.length;

      for (let a = 0; a < i; a++) {
        this.newsList.push({
          picture_url: "",
          title: "",
          subtitle: "",
          link_url: "",
          flag: false,
        });
      }
      this.total_page = Math.ceil(result.data.data.total / 5);
    },
    getNextPage(num) {
      this.getData(num);
      console.log(num);
    },
    rollScroll(event) {
      let _that = this;
      // chrome、ie使用的wheelDelta，火狐使用detail
      let scrollVal = event.wheelDelta || event.detail;
      // 节流
      if (!_that.timeOut) {
        _that.timeOut = setTimeout(() => {
          _that.timeOut = null;
          scrollVal > 0
            ? _that.$refs.carousel.prev()
            : _that.$refs.carousel.next();
        }, 700);
      }
    },

    goto(href) {
      window.location = href;
    },
  },
};
</script>
